import { useCallback } from 'react';

import { useDashboardApiContext } from '@projects/components/EMDashboardPage/useDashboardAPIContext';
import useFullColumnsData from './useFullColumnsData';

const getSuggestedColumns = ({ suggestedTableColumns }) => {
  return suggestedTableColumns.map(
    ({ projectColumnId }) => projectColumnId.split('--')[0]
  );
};

const getSuggestedGroups = ({ suggestedGroupingColumns }) => {
  return suggestedGroupingColumns.map(
    ({ projectColumnId }) => projectColumnId.split('--')[0]
  );
};

export default function useSuggestedViewFields() {
  const {
    columns,
    isColumnsSuccess: isColumnsReady
  } = useDashboardApiContext();

  const getSuggestedViewFields = useCallback(
    suggestedFieldsData => {
      return {
        columns: getSuggestedColumns(suggestedFieldsData),
        panels: [],
        groups: getSuggestedGroups(suggestedFieldsData)
      };
    },
    [columns]
  );

  return useFullColumnsData(null, {
    select: getSuggestedViewFields,
    enabled: isColumnsReady
  });
}
